import React, { memo, useCallback } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from './values';
import DateRangeSelector from './date/DateRangeSelector';
import Text from './Text';
const DateOfMonthPicker = ({ title, onSelect, selectedDay, style, }) => {
    const onDateSelect = useCallback((day) => {
        onSelect(day);
    }, [onSelect]);
    return (<View style={[styles.container, style]}>
      {!!title && (<Text Text-16 centered style={styles.title}>
          {title}
        </Text>)}
      <DateRangeSelector small type="single" start={selectedDay} onChange={onDateSelect}/>
    </View>);
};
export default memo(DateOfMonthPicker);
const styles = StyleSheet.create({
    title: {
        padding: rem(20),
    },
    container: {
        paddingHorizontal: rem(8),
    },
});
